import type { ReactNode } from 'react';
import { Icon } from './Icon';
import type { IconName } from './Icon';

export function EmptyState({
  title,
  message,
  icon = 'menu',
  action,
}: {
  title: string;
  message?: string;
  icon?: IconName;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <span className="grid size-12 place-items-center rounded-full bg-surface text-muted">
        <Icon name={icon} size={24} />
      </span>
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      {message && <p className="max-w-xs text-sm text-muted">{message}</p>}
      {action}
    </div>
  );
}
